import { AUTH_TOKEN, AUTH_TOKEN_DOMAIN, AUTH_TOKEN_ORG_LOGIN, getDomainUrl, getToken, isEmpty } from "../utils/helpers";

const axiosHeaders = (isFormData = false, curentPath) => {
    const paths = ["/authnz/getUserDetails"];
    const headers = {
        "Content-Type": isFormData ? "multipart/form-data" : "application/json",
        withCredentials: true,
    };

    const token = getToken();
    if (!isEmpty(token)) {
        if (paths.includes(curentPath)) {
            const domainUrl = getDomainUrl();
            headers["X-Authorization"] = domainUrl === "app.authnull.com" ? AUTH_TOKEN_ORG_LOGIN() : AUTH_TOKEN_DOMAIN();
            headers["x-requesturl"] = getDomainUrl();
        } else {
            headers["X-Authorization"] = AUTH_TOKEN();
        }
    }

    const headersInfo = { headers: { ...headers } };
    return headersInfo;
};


// factory to create request helpers bound to a specific axios instance
export const requestsFor = (instance) => ({
    get: async (path) => {
        return await instance.get(path, axiosHeaders());
    },
    post: async (path, params, isFormData) => {
        return await instance.post(path, params, axiosHeaders(isFormData, path));
    },
    put: async (path, params, isFormData) => {
        return await instance.put(path, params, axiosHeaders(isFormData, path));
    },
    delete: async (path, params, isFormData) => {
        return await instance.delete(path, {
            data: params,
            headers: axiosHeaders(isFormData, path).headers,
        });
    },
});